export default __webpack_public_path__ + "static/overlay-4eb7fba5e2d8704c61462cf4a5a3021a.png";